export default __webpack_public_path__ + "static/media/space.5c982925.png";